import { paths } from 'src/routes/paths';

export const { VITE_APP_API_URL: APP_API_URL } = import.meta.env;

export const STORAGE_KEY_ACCESS = '@nectar-backoffice/access_token';
export const STORAGE_KEY_REFRESH = '@nectar-backoffice/refresh_token';

export const PATH_AFTER_LOGIN = paths.root;
export const PATH_AFTER_LOGOUT = paths.auth.login;
